//import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ApplicationRef, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToasterModule } from 'angular2-toaster';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FacebookModule } from 'ngx-facebook';
import { AuthService } from 'angular2-google-login';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
/*import { NotifyService } from './services/notify.service';*/

import { ErrorComponent } from './pages/shared/components/errorComponent/error.component';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';
import { Environment } from 'environments/environment';

/* Firebase init */
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
// import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';

/* stomp start */
// import { StompConfig, StompService } from '@stomp/ng2-stompjs';
// import {stompConfig} from './models/rx-stomp-config';

/* stomp end*/

// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';
import { ServicesModule } from './services/services.module';
import { PagesModule } from './pages/pages.module';
import { AuthGuard, PureGuard } from './guards';
import { ComParentChildService } from './services/parent-child.service';
import { DashboardService } from './pages/shared/services/dashboard.service';
import { CustomerService } from './pages/admin/components/customers/services/customer.service';
import { AuthenticationService } from './services/index';
import { Constants } from './app.constant';
// import { PushNotificationService } from './services';
import { StompServiceModule } from './stomp-module/stomp-service.module';
// import {PushNotificationService} from './services/push-notification.service'

// Application wide providers
const APP_PROVIDERS = [
  AppState,
  GlobalState,
  PureGuard,
  AuthGuard,
  AuthService,
  DashboardService,
  CustomerService,
  AuthenticationService
];

const FIREBASE_INIT = (Constants.Var.sslOn) ? [
  AngularFireModule.initializeApp(Environment.firebase),
  AngularFireDatabaseModule,
  // AngularFireAuthModule,
  AngularFirestoreModule,
] : [];
//console.log("FIREBASE_INIT == >", FIREBASE_INIT)

// const checkForUserLogin=()=>{
//   if(Constants.CurrentUserInfomations("userId") != null){
//     console.log("after Login Check Vicky called")
//      return stompConfig;
//   }
// }
// console.log("stomp Config ==>", typeof stompConfig, " ghghg ==> ", stompConfig) // object
// const STOMP_SERVICE=(!Constants.Var.sslOn && stompConfig.url !== null)?[
//   StompService,
//   {
//     provide: StompConfig,
//     useValue: stompConfig
//   }
// ]: [];

export type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/* config for stomp start */
// const stompConfig: StompConfig = {

//   // How often to heartbeat?
//   // Interval in milliseconds, set to 0 to disable
//   heartbeat_in: 0, // Typical value 0 - disabled
//   heartbeat_out: 20000, // Typical value 20000 - every 20 seconds

//   // Wait in milliseconds before attempting auto reconnect
//   // Set to 0 to disable
//   // Typical value 5000 (5 seconds)
//   reconnect_delay: 5000,

//   // Will log diagnostics on console
//   debug: true
// };
/* config for stomp end */


/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [App],
  declarations: [
    App
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    HttpModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgaModule.forRoot(),
    ServicesModule.forRoot(),
    FacebookModule.forRoot(),
    NgbModule.forRoot(),
    // StompServiceModule.forRoot(),
    PagesModule,
    ToasterModule,
    FIREBASE_INIT,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    routing

  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    APP_PROVIDERS,
    ErrorComponent, ComParentChildService,
    Title,
    ErrorComponent, ComParentChildService,
    // STOMP_SERVICE,
    // {
    //   provide: PushNotificationService,
    //   useClass: StompService
    // }

    // PushNotificationService,
    // {
    //   provide: StompConfig,
    //   useValue: rxStompConfig
    // },
    // {
    //   provide: RxStompService,
    //   useFactory: rxStompServiceFactory,
    //   deps: [InjectableRxStompConfig]
    // },
    // SocketService,
    // WebsocketService,
  ]
})

export class AppModule {

  constructor(public appState: AppState) {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts